import { Middleware } from 'redux';

import {
  successCreateGroup,
  successDestroyGroup,
  successReadGroupsAll,
  successReadGroupsRelated,
  successUpdateGroup
} from '../actions/group';
import {
  failCalling,
  finishCalling,
  noInternetCalling,
  startCalling
} from '../actions/network';
import DeleteGroup from '../apis/DeleteGroup';
import GetGroupsAll from '../apis/GetGroupsAll';
import GetGroupsRelated from '../apis/GetGroupsRelated';
import PostGroup from '../apis/PostGroup';
import PutGroup from '../apis/PutGroup';

const MIDDLEWARE = 'groups';

const groupsMiddleware: Middleware = store => next => action => {
  switch (action.type) {
    case 'READ_GROUPS_ALL':
      readGroupsAll(store, action);
      break;

    case 'READ_GROUPS_RELATED':
      readGroupsRelated(store, action);
      break;

    case 'CREATE_GROUP':
      createGroup(store, action);
      break;

    case 'UPDATE_GROUP':
      updateGroup(store, action);
      break;

    case 'DESTROY_GROUP':
      destroyGroup(store, action);
      break;
  }
  next(action);
};

const readGroupsAll = (store: any, action: any) => {
  const METHOD = 'readGroupsAll';
  console.log(MIDDLEWARE + ':' + 'Call API: GetGroupsAll');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetGroupsAll();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        groups => {
          store.dispatch(successReadGroupsAll(groups));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readGroupsRelated = (store: any, action: any) => {
  const METHOD = 'readGroupsRelated';
  console.log(MIDDLEWARE + ':' + 'Call API: GetGroupsRelated');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetGroupsRelated();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        groups => {
          store.dispatch(successReadGroupsRelated(groups));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const createGroup = (store: any, action: any) => {
  const METHOD = 'createGroup';
  console.log(MIDDLEWARE + ':' + 'Call API: PostGroup');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PostGroup();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.group, store.getState().Account).then(
        group => {
          store.dispatch(successCreateGroup(group));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const updateGroup = (store: any, action: any) => {
  const METHOD = 'updateGroup';
  console.log(MIDDLEWARE + ':' + 'Call API: PutGroup');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PutGroup();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.group, store.getState().Account).then(
        group => {
          store.dispatch(successUpdateGroup(group));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const destroyGroup = (store: any, action: any) => {
  const METHOD = 'destroyGroup';
  console.log(MIDDLEWARE + ':' + 'Call API: DeleteGroup');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new DeleteGroup();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.group, store.getState().Account).then(
        group => {
          store.dispatch(successDestroyGroup(action.group));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

export default groupsMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/groups.ts